import { html } from "lit";
var icon_success_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g fill-rule="evenodd">
      <path
        d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2zm0 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4z" />
      <path
        d="M23.165 10.141a.65.65 0 01.083.083.905.905 0 010 1.152l-3.803 4.609-.95 1.152-3.043 3.69.009-.006-.604.754-.016-.003-.037.072a1.081 1.081 0 01-.056.082.656.656 0 01-1.007.046l-2.166-2.362-.6-.654-2.188-2.388a.916.916 0 01-.06-1.162.624.624 0 01.96-.048l2.188 2.387.6.654 1.733 1.83 3.336-4.043.95-1.152 3.803-4.609a.617.617 0 01.868-.083z" />
    </g>
  </svg>
`;
export {
  icon_success_default as default
};
//# sourceMappingURL=icon-success.js.map
